import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, Bell, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import SEO from "../components/SEO";

export default function ShopComingSoon() {
    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-24 relative overflow-hidden" data-testid="shop-coming-soon">
            <SEO title="Coming Soon — Real-Check Shop" path="/shop" description="The Real-Check merch store is launching soon." noindex />

            {/* Ambient glow */}
            <div className="absolute inset-0 -z-10 opacity-30 pointer-events-none">
                <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-primary/40 blur-3xl" />
            </div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="max-w-2xl w-full text-center"
            >
                <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ delay: 0.15, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    className="inline-flex items-center gap-2 px-4 py-1.5 mb-6 rounded-full bg-primary/15 border border-primary/40 text-primary text-sm font-medium tracking-wide uppercase"
                >
                    <Sparkles className="h-3.5 w-3.5" />
                    Coming Soon
                </motion.div>

                <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-accent leading-[1.05] tracking-tight">
                    Check Back Soon
                </h1>

                <p className="mt-6 text-lg text-muted-foreground max-w-lg mx-auto leading-relaxed">
                    The Real-Check merch store is getting one final polish. Every pre-order still splits
                    <span className="text-accent font-semibold"> 50 / 50</span> to fund Hands of Hope — we&apos;ll
                    be back in your hands very soon.
                </p>

                <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
                    <Link to="/">
                        <Button variant="outline" className="rounded-full gap-2" data-testid="shop-coming-soon-home-btn">
                            <ArrowLeft className="h-4 w-4" />
                            Back to home
                        </Button>
                    </Link>
                    <Link to="/donate">
                        <Button className="rounded-full gap-2" data-testid="shop-coming-soon-donate-btn">
                            <Bell className="h-4 w-4" />
                            Support the mission
                        </Button>
                    </Link>
                </div>

                <p className="mt-8 text-xs text-muted-foreground uppercase tracking-wider">
                    Follow @realcheckorg for the launch drop
                </p>
            </motion.div>
        </div>
    );
}
